module.exports = __webpack_public_path__ + "img/obd.bda04340.png";